// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectEntitlementProductSubscriptionResponseMessage } from "../../../../Utils/DirectMessages/DirectMessagesImport.ts";
export let EntitlementProductSubscriptionResponseMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

EntitlementProductSubscriptionResponseMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

EntitlementProductSubscriptionResponseMessageProcessor.prototype.decode = function (fs)
{
    let msg = new DirectEntitlementProductSubscriptionResponseMessage()
    let ff = FieldsFactory

    msg.Id = fs.GetValue(ff.FIELD_PRODUCT_ID);
    msg.ReqStatus = fs.GetValue(ff.FIELD_PRODUCT_REQUEST_STATUS);
    msg.ReqType = fs.GetValue(ff.FIELD_PRODUCT_REQUEST_TYPE);
    msg.ReqTime = fs.GetValue(ff.FIELD_PRODUCT_REQUEST_TIME);
    msg.ResponseEnd = fs.GetValue(ff.FIELD_RESPONCE_END);
    msg.ErrorCode = fs.GetValue(ff.FIELD_ERROR_CODE);
    msg.Comment = fs.GetValue(ff.FIELD_COMMENT);

    return [msg]
}